import * as styleConstants from "@affinity/constants/StyleConstants";
import * as styleHelpers from "@affinity/constants/StyleHelpers";
import React, { FC } from "react";
import styled from "styled-components";

const RangeContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding: ${styleHelpers.rem(5)} 0;
    @maedia (min-width: ${styleHelpers.breakpointWidth("md")}) {
        padding: ${styleHelpers.rem(30)} 0;
    } ;
`;

const StyledInput = styled.input`
    width: 100%;
    height: ${styleHelpers.rem(24)};
    border: none;
    background: none;
    overflow: hidden;
    -webkit-appearance: none;

    &[type="range"]::-webkit-slider-runnable-track {
        -webkit-appearance: none;
        height: ${styleHelpers.rem(4)};
        border-radius: ${styleHelpers.rem(4)};
        background-color: ${styleConstants.colours.lightGreen};
    }

    &[type="range"]::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: ${styleHelpers.rem(24)};
        height: ${styleHelpers.rem(24)};
        margin: -${styleHelpers.rem(10)} 0 0 0;
        background-color: ${styleConstants.colours.white};
        border: solid ${styleHelpers.rem(2)} ${styleConstants.colours.lightGreen};
        border-radius: 50%;
        color: ${styleConstants.colours.lightGreen20};
        position: relative;
        overflow: visible;
        clip-path: path("M 12 24 A 1 1 0 0 1 12 0 A 1 1 0 0 1 12 24 Z M 23 9.5 L 9999 9.5 L 9999 14.5 L 23 14.5 Z");
        box-shadow: 0px 0 0 100vw;
    }

    &[type="range"]::-moz-range-track {
        -moz-appearance: none;
        height: ${styleHelpers.rem(4)};
        border-radius: ${styleHelpers.rem(4)};
        border: none;
        background-color: ${styleConstants.colours.lightGreen20};
    }
    &[type="range"]::-moz-range-progress {
        -moz-appearance: none;
        background-color: ${styleConstants.colours.lightGreen};
        border: none;
    }
    &[type="range"]::-moz-range-thumb {
        -moz-appearance: none;
        width: ${styleHelpers.rem(20)};
        height: ${styleHelpers.rem(20)};
        margin: -${styleHelpers.rem(20)} 0 0 0;
        background-color: ${styleConstants.colours.white};
        border: solid ${styleHelpers.rem(2)} ${styleConstants.colours.lightGreen};
        border-radius: 50%;
    }
`;

const FullWidthRange: FC<React.InputHTMLAttributes<HTMLInputElement>> = props => {
    return (
        <RangeContainer>
            <StyledInput
                type="range"
                value={props.value}
                step={props.step}
                min={props.min}
                max={props.max}
                id={props.id}
                onChange={props.onChange}
            />
        </RangeContainer>
    );
};

export default FullWidthRange;
